// extracted by mini-css-extract-plugin
module.exports = {"header__text":"header__text-3eV4N","close":"close-227Pf","message_restrictionsRejectSeats":"message_restrictionsRejectSeats-2XNVo"};